// extracted by mini-css-extract-plugin
module.exports = {"table-section-container":"DashboardTable_table-section-container__rwFlI"};